import React, { useState } from "react";
import { useFormikContext } from "formik";
import FormActions from "components/FormActions";
import InfoIcon from "components/InfoIcon";
import { DragDropContext } from "react-beautiful-dnd";
import FeatureGroupForm from "components/FeaturesSection/FeatureGroupForm";
import FeatureGroupsDragList from "components/FeaturesSection/FeatureGroupsDragList";
import {
  addFeatureGroups,
  updateFeatureGroupFeatures,
  updateMultipleFeatureGroupFeatures
} from "utils/feature";
import Padder from "components/Padder";
import { ADD_FEATURE_GROUP, DRAG_FEATURE } from "utils/analytics";
import { PAGE_BUILDER_FEATURE_GROUPS_ONBOARDING } from "constants/education";

const FeatureTableDragContainer = ({ hideSaveAction, products, tracking }) => {
  const [selections, setSelections] = useState([]);
  const {
    values,
    setValues,
    setTouched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const hasFeatureGroups =
    Array.isArray(values.featureGroups) && values.featureGroups.length;

  const toggleSingleSelection = (uuid) => {
    setSelections([uuid]);
  };

  const toggleCmdSelection = (uuid) => {
    const selectionIndex = selections.indexOf(uuid);

    if (selectionIndex > -1) {
      selections.splice(selectionIndex, 1);
    } else {
      selections.push(uuid);
    }

    setSelections([...selections]);
  };

  const toggleShiftSelection = (uuid) => {
    console.log("**** multi select");
  };

  const commonProps = {
    products,
    selections,
    tracking,
    setSelections,
    toggleSingleSelection,
    toggleCmdSelection,
    toggleShiftSelection
  };

  const dragTracking = {
    event: DRAG_FEATURE,
    data: { ...tracking }
  };

  const onDragEnd =
    selections.length > 1
      ? updateMultipleFeatureGroupFeatures({
          selections,
          values,
          setValues,
          setTouched,
          tracking: dragTracking,
          callback: () => {
            setSelections([]);
          }
        })
      : updateFeatureGroupFeatures({
          values,
          setValues,
          setTouched,
          tracking: dragTracking
        });

  const mainFeatureGroupContent = (
    <DragDropContext onDragEnd={onDragEnd}>
      <FeatureGroupsDragList {...commonProps} />
    </DragDropContext>
  );

  const noFeaturesPrompt = (
    <div className="ph3">
      <div className="ba hairline-1 pa3 bg-white">
        <FeatureGroupForm
          copy={{
            title: "Add your first feature group",
            body:
              "Once you have your first feature group, you can begin to add your product features to it."
          }}
          placeholder="e.g. Essentials"
          addFeatureGroups={addFeatureGroups({
            tracking: {
              event: ADD_FEATURE_GROUP,
              data: tracking
            },
            values,
            setFieldValue,
            setFieldTouched
          })}
        />
      </div>
    </div>
  );

  const content = hasFeatureGroups ? mainFeatureGroupContent : noFeaturesPrompt;

  return (
    <div className="w-100 flex flex-column relative">
      <div className="w-100 flex flex-row justify-between items-center pa3 sticky top-0 z-2 bg-white bb hairline-1">
        <FormActions
          hideSaveAction={hideSaveAction}
          customClasses={{
            container: "w-100 flex flex-row justify-between"
          }}
        >
          <InfoIcon uid={PAGE_BUILDER_FEATURE_GROUPS_ONBOARDING} />
        </FormActions>
      </div>
      <div className="pt3">{content}</div>
      <Padder theme="visible" />
    </div>
  );
};

export default FeatureTableDragContainer;
